import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import Logo from "../assets/icons/pitchers.png";
import api from "../config/axios";
import "../assets/background/image.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/auth/login", { email, password });

      // Check if the token exists in the response
      if (response.data.token) {
        // Store the token and user data in localStorage
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        // Redirect to the home page
        navigate("/home");
      } else {
        // If no token returned, display an error
        setError("Invalid credentials. Please try again.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-form-container">
          <div className="login-logo">
            <img src={Logo} alt="Pitchers" />
            <h2>Pitchers</h2>
          </div>
          <h1>Log In</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                placeholder="Enter your email address..."
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter your password..."
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="form-options">
              <label className="remember-me">
                <input type="checkbox" /> Remember me
              </label>
              <Link to="/forgot-password" className="forgot-password">
                Forgot Password?
              </Link>
            </div>
            <button type="submit" className="login-button">
              Log In
            </button>
            {error && <div className="error-message">{error}</div>}
            <div className="signup-prompt">
              Not a member? <Link to="/sign-up">Sign up now</Link>
            </div>
            <div className="divider">
              <span>OR</span>
            </div>
            <div className="social-logins">
              <button className="google-login">
                <svg className="social-icon" viewBox="0 0 48 48">
                  <path
                    fill="#FFC107"
                    d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12
                    c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24
                    c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                  />
                  <path
                    fill="#FF3D00"
                    d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657
                    C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                  />
                  <path
                    fill="#4CAF50"
                    d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946
                    l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                  />
                  <path
                    fill="#1976D2"
                    d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002
                    l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                  />
                </svg>
                Continue with Google
              </button>
              <button className="apple-login">
                <svg className="social-icon" viewBox="0 0 384 512">
                  <path
                    fill="currentColor"
                    d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7
                    C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9
                    48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9
                    -17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                  />
                </svg>
                Continue with Apple
              </button>
              <button className="facebook-login">
                <svg className="social-icon" viewBox="0 0 48 48">
                  <rect width="48" height="48" rx="8" fill="#1877F2" />
                  <path
                    d="M32.2721 25.0428L33.1427 19.3008H27.6187V15.6389C27.6187 14.0331 28.4035 12.4706 30.8583 12.4706H33.4297V7.58333
                    C33.4297 7.58333 31.1692 7.20833 29.0049 7.20833C24.4861 7.20833 21.5183 9.98245 21.5183 14.9925V19.3008H16.4766V25.0428H21.5183
                    V39.7917H27.6187V25.0428H32.2721Z"
                    fill="white"
                  />
                </svg>
                Continue with Facebook
              </button>
            </div>
            {error && <div className="error-message">{error}</div>}
          </form>
        </div>
      </div>
      <div className="login-right">
        <img
          src={require("../assets/background/image.png")}
          alt="background"
          className="background-image"
        />
        <div className="promo-content">
          <div className="promo-text">
            <h2>Join the largest</h2>
            <h2>Designer</h2>
            <h2>
              community <span>in</span>
            </h2>
            <h2>
              <span>the world</span>
            </h2>
          </div>
          <p>
            Step into the world of creativity and innovation by joining the
            largest designer community globally. Connect, inspire, and grow with
            thousands of talented designers shaping the future of design.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
